"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _reactI18next = require("react-i18next");
var _Button = _interopRequireDefault(require("../Button"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _api = require("../../api");
var _checkmarkBase = _interopRequireDefault(require("../../assets/images/checkmarkBase"));
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _popupSlice = require("../../redux/popupSlice");
var _util = require("../../util");
var _InnerPopupWrapperStyled = require("../InnerPopupWrapper/InnerPopupWrapperStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CancelPausePopup = () => {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isError, setIsError] = (0, _react.useState)(false);
  const [step, setStep] = (0, _react.useState)(1);
  const {
    data: allSwitchDetails
  } = (0, _reactRedux.useSelector)(state => state.plan.switchDetails);
  const {
    cancelPause: {
      pendingSwitchId,
      baseOfferExpirationDate,
      baseOfferPrice,
      baseOfferTitle
    }
  } = (0, _reactRedux.useSelector)(state => state.popupManager);
  const switchDetails = allSwitchDetails[pendingSwitchId];
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const eventsPayload = {
    pendingSwitchId,
    fromOfferId: switchDetails === null || switchDetails === void 0 ? void 0 : switchDetails.fromOfferId,
    toOfferId: switchDetails === null || switchDetails === void 0 ? void 0 : switchDetails.toOfferId
  };
  const dispatch = (0, _reactRedux.useDispatch)();
  const cancelPause = async () => {
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_CANCEL_SWITCH_ACTION_TRIGGERED, eventsPayload);
    setIsLoading(true);
    try {
      const {
        errors
      } = await (0, _api.updateSwitch)(pendingSwitchId);
      if (!errors.length) {
        setIsLoading(false);
        dispatch((0, _planDetailsSlice.setSwitchDetails)({
          details: {
            pendingSwitchId
          },
          type: 'delete'
        }));
        setStep(2);
        (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_CANCEL_SWITCH_ACTION_SUCCESSFUL, eventsPayload);
      } else {
        setIsError(true);
        setIsLoading(false);
        (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_CANCEL_SWITCH_ACTION_FAILED, {
          ...eventsPayload,
          reason: errors[0]
        });
      }
    } catch {
      setIsError(true);
      setIsLoading(false);
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_CANCEL_SWITCH_ACTION_FAILED, eventsPayload);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapper.default, {
    steps: 2,
    popupTitle: t('cancelpause-popup.title', 'Cancel pause'),
    currentStep: step,
    isError: isError,
    children: [step === 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          children: t('cancelpause-popup.title', 'Cancel pause')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: t('cancelpause-popup.information-text', 'Your current plan will be paused starting on {{baseOfferExpirationDate}}. Cancel the pause to resume access to your {{ pausedOfferTitle }} subscription. While your subscription is paused, you won’t be charged for, and you won’t have access to, {{ pausedOfferTitle }}.', {
            baseOfferExpirationDate: (0, _util.dateFormat)(baseOfferExpirationDate),
            baseOfferPrice,
            pausedOfferTitle: baseOfferTitle
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: t('cancelpause-popup.question-text', 'Would you like to cancel the pause request?')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        $removeMargin: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "simple",
          onClickFn: () => {
            (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_CANCEL_SWITCH_ACTION_CANCELLED, eventsPayload);
            dispatch((0, _popupSlice.hidePopup)());
          },
          children: t('cancelpause-popup.resign', 'No, thanks')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "danger",
          onClickFn: cancelPause,
          children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#ffffff"
          }) : t('cancelpause-popup.confirm-button-text', 'Cancel pause')
        })]
      })]
    }), step === 2 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _checkmarkBase.default,
          alt: "checkmark icon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          children: t('cancelpause-popup.confirmation-title', 'Your pause request has been canceled.')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: t('cancelpause-popup.confirmation-text', 'Your access to your {{ pausedOfferTitle }} subscription will continue.', {
            pausedOfferTitle: baseOfferTitle
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        $removeMargin: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: () => {
            dispatch((0, _planDetailsSlice.updateList)());
            dispatch((0, _popupSlice.hidePopup)());
          },
          children: t('cancelpause-popup.back-button', 'Back to My Account')
        })
      })]
    })]
  });
};
var _default = exports.default = CancelPausePopup;